module.exports = __webpack_public_path__ + "img/tiandi.b6c58aa3.png";